import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AboutPage from './pages/AboutPage';
import AdminPage from './pages/AdminPage';
import CustomerDashboard from './pages/CustomerDashboard';
import ForumPage from './pages/ForumPage'; // IMPORT FORUM PAGE

function App() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedRole = localStorage.getItem('role');
    
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
        setRole(storedRole);
      } catch (e) {
        console.error("Error parsing user data", e);
        localStorage.clear();
      }
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900"></div>
      </div>
    );
  }

  const isRealAdmin = (user?.email || "").trim().toLowerCase() === 'shripadkhadilkar@gmail.com';
  const hasAdminAccess = role === 'ADMIN' || isRealAdmin;

  return (
    <Router>
      <div className="min-h-screen bg-gray-50 text-gray-800 font-sans">
        <Navbar user={user} isRealAdmin={isRealAdmin} setUser={setUser} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage user={user} />} />
          
          {/* NEW FORUM ROUTE */}
          <Route path="/forum" element={<ForumPage user={user} isRealAdmin={isRealAdmin} role={role} />} />
          
          <Route path="/login" element={<LoginPage setUser={setUser} setRole={setRole} />} />
          <Route path="/register" element={<RegisterPage setUser={setUser} setRole={setRole} />} />

          <Route 
            path="/admin" 
            element={hasAdminAccess ? <AdminPage user={user} /> : <Navigate to="/" replace />} 
          />

          <Route 
            path="/customer" 
            element={user && !isRealAdmin ? <CustomerDashboard user={user} /> : <Navigate to="/admin" replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;